export enum EExceptionUITypes {
  MissPunch = "missPunch",
  NoEmpApprove = "noEmpApprove",
  NoSupApprove = "noSupApprove",
  BioException = "bioException",
  LocException = "locException",
  ScheduleMissingInPunch = "scheduleMissingInPunchException",
  ScheduleEarlyInPunch = "scheduleEarlyInPunchException",
  ScheduleLateInPunch = "scheduleLateInPunchException",
  ScheduleEarlyOutPunch = "scheduleEarlyOutPunchException",
  ScheduleLateOutPunch = "scheduleLateOutPunchException",
  ScheduleMissingBreak = "scheduleMissingBreakException",
  ScheduleLongBreak = "scheduleLongBreakException",
  ScheduleNoShift = "scheduleNoShiftException",
  QuestionException = "prePunchScreeningException",
  // unapproved timeoffs should be shown in ExceptionPunchSet
  Timeoff = "timeoff",

  // supervisor notification need Timeoff
  DeviceStatus = "deviceStatusException",
  SuspensePunch = "suspensePunch",

  TimeFraud = "timeFraud",

  // supervisor notification need PunchNote
  PunchNote = "punchNote",

  // supervisor notification need CA Meal Break Exception Notification
  CAMealBreakException = "CAMealBreakException",

  MinimumBreakOverride = "minimumBreakOverride"
}